import { render, staticRenderFns } from "./LessonEditorDetails.vue?vue&type=template&id=4dea145c&"
import script from "./LessonEditorDetails.vue?vue&type=script&lang=js&"
export * from "./LessonEditorDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports